import { Reply } from "@mui/icons-material";
import { Box, Button, Drawer, drawerClasses, Fab } from "@mui/material";
import { IconButton } from "components/Form";
import { layoutTypes } from "keys";
import styled, { css } from "styled-components";
import { Center, Scroll, Shadow, FabShadow, Disabled, Removed, ScrollCss } from "styles/GlobalCss";
import { CustomSection, WrapHeader as GlobalHeader } from "styles/GlobalStyle";
import { gray, error, light, ligthGray, white, dark, yellow, gTheme, primary, secondary, rating4 } from "styles/theme";
import { styled as muiStyled } from '@mui/material/styles';
import { thirdly } from "styles/theme";
import { borderRadius, display, fontFamily, fontSize, fontWeight, height, positions } from "@mui/system";
import { thirdly2 } from "styles/theme";

export const pointTimeWidth = '25px'

export const ReplyIcon = styled(Reply)`
transform: scaleX(-1);
`

export const StudentWordListStyles = muiStyled(Box)(({ cardWidth, cardHeight, fontSize, theme, $systemUI }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: '100%',
  width: "100%",
  '.place-holder': {
    border: "1px solid #E0E0E0",
    color: "#E0E0E0",
    borderRadius: 5,
    height: 53,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  '.word-item': {
    height: cardHeight || 82,
    display: "flex",
    flexDirection: "column",
    justifyContent: "end"
  },
  '.wrap-words-and-next-button': {
    display: "flex",
    columnGap: 40,
  },
  '.wrap-go-prev-page': {
    display: "flex",
    alignItems: "end",
    position: "relative",
    bottom: 20
  },
  '.bold-word-text': {
    fontWeight: "bold"
  },
  '.example-arrow': {
    position: "absolute",
    bottom: 30,
    left: 100
  },
  '.wrap-example-arrow': {
    transform: "translateZ(0px)",
    flexShrink: 0,
    zIndex: 10
  },
  '.wrap-word-list': {
    height: '100%',
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  '.go-next-page': {
    width: 100
  },
  '.wrap-words': {
    columnCount: 3,
    columnGap: 65,
    rowGap: 40,
  },
  '.word-content': {
    display: "flex",
    breakInside: "avoid",
    marginBottom: 20
  },
  '.word': {
    border: `1.34px solid ${thirdly}`,
    borderRadius: 10,
    fontFamily: [
      "Secular One", "sans-serif"
    ].join(','),
    fontWeight: 400,
    fontStyle: "normal",
    height: 30,
    width: cardWidth || 220,
    height: 160,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: fontSize || "2.5rem",
  },
  '.vowel': {
    position: "relative",
    left: 2,
  },
  '.vowel1': {
    position: "relative",
    top: 5
  },
  '.bold-word': {
    border: `2px solid black`,
  },
  '.special-vowel': {
    position: "relative",
    left: 20,
    top: "-8px !important"
  }
}));

export const DrawerStyles = muiStyled(Drawer)(({ theme, $systemUI }) => ({
  [`& .${drawerClasses.paper}, & .${drawerClasses.root}`]: {
    width: "100%"
  },
  '.close-drawer': {
    padding: 10
  }
}));

export const WrapWordsContent = styled.div`
flex-grow:1;
${Center};
height:100%;
width:100%;
`

export const FabDetail = styled.div`
width:20px;
height:20px;
background:${props => props.$color};
font-size: 10px;
display: flex;
align-items: center;
justify-content: center;
border-radius: 30px;
padding: 2px;
color: white;
font-weight: bold;
${FabShadow};
`

export const Time = styled.div`
position: relative;
font-size: 20px;
`

export const WrapAssessmentName = styled.div`
// flex-grow:1;
text-align:start;
`

export const GoPerformAssessments = styled(Fab)`

`

export const MuiButton = styled(Button)`
width:310px !important;
display: flex !important;
justify-content: space-around !important;
border-radius: 33px !important;
border: 1px solid #CCE1FF !important;
background: ${white};
color:${dark} !important;
`

export const NumPoints = styled.div`
border-radius: 30px;
padding:5px;
width: 50px;
height: 50px;
background: ${yellow};
color:${white};
font-weight: bold;
font-size:14px;
display:flex;
justify-content:center;
align-items:center;

${FabShadow};
`

export const WrapStudentParagraph = styled.div`
display: flex;
justify-content: center;
align-items:center;
width:100%;
height:100%;
`

export const WordsContentStyles = muiStyled(Box)(({ student, theme, $systemUI }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: 10,
  flexGrow: 1,
  overflow: student ? "hidden" : "auto",
  background: white,
  borderRadius: 10,
  ...ScrollCss,
  '.play-pause-cartoon': {
    transform: "translateZ(0px)",
    flexShrink: 0,
    zIndex: 10,
    '.MuiButtonBase-root.MuiIconButton-root': {
      position: "absolute",
      top: 377,
      left: 246,
      background: thirdly2
    }
  }
}));


export const WrapWordText = styled.div`
display: flex;
flex-direction: column;
width:100%
`

export const PointTime = styled.span`
font-weight:bold;
width:${pointTimeWidth};
display: flex;
align-items: center;
height:10px;
font-size: 18px;
`

export const WrapMarkWordsContent = styled.div`
${props => props.$disabled && Disabled} 
height: 100%;
display:flex;
align-items: ${props => props.student ? "center" : "start"};
`

export const WrapHeaderActions = styled.div`
display: flex;
column-gap: 10px;
align-items:center;

`

export const WrapScreenMarkWords = styled.div`
display: flex;
flex-direction: column;
height: 100%;
flex-grow: 1;
box-sizing: border-box;
flex: 1 1 auto;
overflow:auto;

.wrap-speaker-cartoon{
  transform: translateZ(0px);
  flexShrink: 0;
  zIndex: 10;
  width: 0px;
  height: 700px;
  position: relative;
  z-index:2;
}

.wrap-assessment-cartoon{
  transform: translateZ(0px);
  flexShrink: 0;
  zIndex: 10;
  width:100%;

}

.assessment-cartoon{
  width:100px;
  height:100px;
  position: absolute;
  bottom:0px;
  right:10px;
}

.speaker-cartoon{
width:600px;
height:600px;
position: absolute;
}

.go-prev-page{
    // width: 100px;
    // position: absolute;
    // bottom:70px;
    // left:70px;

    .MuiButtonBase-root.MuiIconButton-root{
      background: ${secondary};
      path{
        fill: white
      }
    }
}

.play-pause-cartoon{

}
`

export const SelectTimePointP = styled.div`
position: relative;
width: 20px;

*:focus {
  outline: none;
}


select{
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  border:1px solid ${ligthGray};
  color:${dark};
  background:transparent;
  border-radius:2px;
  padding:1px;
}

// border:1px solid red;
`

export const SelectTimePoint = styled(SelectTimePointP)`

`

export const WrapFooter = styled.div`
display: flex;
justify-content: end;
column-gap: 10px;
height:70px;
align-items: center;
`

export const WrapSettings = styled.div`
display:flex;
justify-content: space-between;
width: 100%;
`

export const SelectWord = styled.div`
border-radius: 30px;
position: relative;
top: 13px;
${Center};
${Shadow};
z-index: 2;
cursor:pointer;


.error-icon{
  width:12px;
  height:12px;
  color:${props => props.color};
  background:transparent;

}
`

export const SelectWordP = styled(SelectWord)`
top: 3px;
left: 0px;
`

export const WrapInput = styled.input`
width:27px; 
height:28px;
border:${props => `1px solid ${props.color}`};
color:${props => `${props.color}`};
border-radius:30px;
text-align: center;
`

export const WordSettings = styled.span`
display: flex;
column-gap: 10px;
`

export const WordBorderCss = css`
border-width: 2px;
border-style:${props => props.$customStatus ? "dashed" : "solid"};
border-color:${props => props.$error
    ? error :
    props.$customStatus ? yellow :
      ligthGray};
border-color:${props => props.$minorError && rating4}; 
${props => props.$removed && Removed}   
`

export const Word = styled.div`
${Shadow};
width:100%;
padding:5px;
box-sizing: border-box;
background:${white};
display: flex;
align-items: center;
justify-content: center;
border-radius: 3px;
${WordBorderCss};
`

export const WrapMarkWordsAndParagraph = css`
text-align: center;
font-size:33px;
height:100%;
`

export const WrapSelectTime = styled.div`

`

export const WordP = styled.span`
${WrapMarkWordsAndParagraph};
font-size:${props => props.small ? "20px" : "33px"};
font-weight:${props => props.$isPointTime && 'bold'};
`

export const WrapWordList = styled.div`
${props => props.layoutType == layoutTypes.row ?
    `
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  `
    :
    `
  column-count: ${props.$markOption ? 6 : 7}; 
  @media only screen and (max-width: 1800px) {
   column-count: ${props.$markOption ? 5 : 6}; 
  }
  @media only screen and (max-width: 1500px) {
   column-count: ${props.$markOption ? 4 : 5}; 
  }
  @media only screen and (max-width: 1300px) {
    column-count: ${props.$markOption ? 3 : 4}; 
  }
  @media only screen and (max-width: 1080px) {
   column-count: ${props.$markOption ? 2 : 3}; 
  }
  `
  }

column-gap: ${props => !props.$markOption && '15px'};
${Scroll}
${WrapMarkWordsAndParagraph};




.insertion-icon{
position: relative;
top: 14px;
${Center}
}
`

export const WrapActionBtn = styled.div`
width:${props => props.width}px;
height:30px;
`

//change source
export const WrapParagraph = styled.div`
flex-wrap: wrap;
row-gap: 5px;
align-items: end;
display: flex;
margin-top:45px;
width:80%;
column-gap: ${props => props.$markOption ? '10px' : '4px'};
overflow:auto;
${props => props.$title && `
width:100%;
justify-content: center;
font-weight: bold;
overflow:hidden;
`}
${Scroll};

.insertion-icon{
    position: relative;
    bottom: 5px;
}
`

export const WrapWordContent = styled.div`
display:flex;
break-inside: avoid;

.word-item{
height: 82px;
display: flex;
flex-direction: column;
justify-content: end;
}
`

export const WrapAddWord = styled.div`
margin-top: 15px;
padding:2px;
display: flex;
align-items: center;
`

export const WrapWord = styled.div`
display: flex;
width:200px;
max-width:100%;
column-gap:7px;
display: flex;
align-items: end;
justify-content:center;
`

export const WrapResult = styled.div`
display: flex;
justify-content: space-between;
`

export const End = styled.div`
width:20px;
height:20px;
background:${secondary};
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    padding: 2px;
    color: white;
    font-weight: bold;
${FabShadow};
`
//change source
export const WrapWordP = styled.span`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
padding:4px;
border-radius: 6px;
${props => props.$error &&
    WordBorderCss
  }
${props => props.$customStatus &&
    WordBorderCss
  }

${props => props.$minorError &&
    WordBorderCss
  }

${props => props.$removed && `${Removed}`} 



`

export const WrapHeader = styled.div`
height:100px;
`

export const HeaderSide = styled.div`
display:flex;
column-gap:7px;
align-items: center;
justify-content: ${props => props.side};
//width:33%;
`

export const WrapCustomSection = styled(CustomSection)`
height:${props => props.$fullHeight ? "100%" : "auto"};
`

export const WrapWordsHeader = styled(GlobalHeader)`
height:50px;
justify-content:space-between;
`
